<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_SCON_REQUEST_COMBO_VIEW')">
    <!-- <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách yêu cầu đăng ký combo bán hàng</h1>
    </div> -->
    <div class="p-10 card pt-15 mt-3">
      <div class="card-header mb-2">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input style="border-radius: 4px" v-model="search.keySearch" placeholder="Từ khoá" />
          </div>
          <div class="form-group">
            <input style="border-radius: 4px" v-model="search.code" placeholder="Mã yêu cầu" />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionCode"
              :options="dataConfigRegion"
              placeholder="Vùng"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="optionStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.paymentStatus"
              :options="optionPaymentStatus"
              placeholder="Trạng thái thanh toán"
            >
            </Select2>
          </div>

          <div class="form-group">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="resetFilters"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="mb-2 custom-label" v-if="pagination?.total">
              Tổng: <span class="text-primary">{{ pagination?.total | formatNumberVN }}</span>
            </div>
            <b-overlay :show="loading" opacity="0.6" rounded="sm">
              <b-table
                sticky-header
                hover
                responsive
                :items="list"
                :fields="tableFields"
                :fixed="true"
                :bordered="true"
              >
                <template #cell(index)="data">
                  {{ getIndex(data.index) }}
                </template>

                <template #cell(infoRequest)="{ item }">
                  <div class="note-content">
                    <div class="mb-1"><span class="text-muted">Mã</span>: {{ item.code }}</div>
                    <div class="mb-1">
                      <span class="text-muted">Tạo</span>:
                      <span v-if="item.createdDate">{{
                        item.createdDate | formatDate('DD/MM/YYYY')
                      }}</span>
                    </div>
                    <div class="mb-1">
                      <span class="text-muted">Cập nhật</span>:
                      <span v-if="item?.updatedDateTime">{{
                        item?.updatedDateTime | formatDate('DD/MM/YYYY')
                      }}</span>
                    </div>
                  </div>
                </template>

                <template #cell(infoMerchant)="{ item }">
                  <div>
                    <div class="mb-1">
                      <span class="text-muted">Tên</span>: {{ item?.merchantName }}
                      <span v-if="item?.phone">- {{ item?.phone }}</span>
                    </div>
                    <div class="mb-1">
                      <span class="text-muted">DKKD</span>: {{ item?.businessRegistrationNumber }}
                    </div>
                    <div class="mb-1">
                      <span class="text-muted">Vùng MC</span>: {{ item?.regionMcName }}
                    </div>
                    <div class="mb-1">
                      <span class="text-muted">Địa chỉ ĐK</span>:
                      {{
                        [item?.address, item?.townName, item?.regionName].filter(Boolean).join(', ')
                      }}
                    </div>
                    <div class="mb-1">
                      <span class="text-muted">Ngành nghề</span>:
                      {{ [item?.businessType, item?.mainType].filter(Boolean).join(', ') }}
                    </div>
                  </div>
                </template>

                <template #cell(infoPackage)="{ item }">
                  <div>
                    <div v-if="item?.invoicePackage?.name" class="mb-1">
                      <span class="text-muted">Tên gói</span>: {{ item.invoicePackage.name }}
                    </div>
                    <div v-if="item?.invoicePackage?.price" class="mb-1">
                      <span class="text-muted">Giá bán</span>:
                      {{ item.invoicePackage.price | formatCurrency }}
                    </div>
                  </div>
                </template>

                <template #cell(infoPayment)="{ item }">
                  <div>
                    <div v-if="item.contractCode" class="mb-1">
                      <span class="text-muted">Mã HĐ/PL</span>: {{ item.contractCode }}
                    </div>
                    <div v-if="item.receiptCode" class="mb-1">
                      <span class="text-muted">Mã Phiếu thu</span>: {{ item.receiptCode }}
                    </div>
                    <div v-if="item.paymentStatus" class="mb-1">
                      <span class="text-muted">Trạng thái</span>:
                      <span class="badge" :class="getPaymentStatusBadgeClass(item.paymentStatus)">{{
                        item.paymentStatusStr || item.paymentStatus
                      }}</span>
                    </div>
                    <div
                      v-if="!item.contractCode && !item.receiptCode && !item.paymentStatus"
                    ></div>
                  </div>
                </template>

                <template #cell(status)="{ item }">
                  <div>
                    <span class="badge" :class="getStatusBadgeClass(item.status)">{{
                      item.statusStr || item.status
                    }}</span>
                  </div>
                </template>

                <template #cell(rejectionNote)="{ item }">
                  <div>
                    <div v-if="item.rejectionNote" class="mb-1">{{ item.rejectionNote }}</div>
                    <div v-if="item.note">{{ item.note }}</div>
                  </div>
                </template>

                <template #cell(action)="{ item }">
                  <b-dropdown right class="m-0 p-0" no-caret>
                    <b-dropdown-item @click="viewDetails(item.id)">Chi tiết</b-dropdown-item>
                    <template v-if="dataPermission?.includes(permissionEdit)">
                      <b-dropdown-item
                        v-if="
                          item &&
                          (item.status === 'NEW' ||
                            (item.statusStr || '').toLowerCase().includes('mới'))
                        "
                        @click="openUpdatePackage(item)"
                      >
                        Chọn lại gói
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="item && item.status === 'NEW'"
                        @click="openConfirmPackage(item)"
                      >
                        Chốt gói sử dụng
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="
                          item &&
                          (item.status === 'NEW' ||
                            (item.statusStr || '').toLowerCase().includes('mới'))
                        "
                        @click="openCancelRequest(item)"
                      >
                        Hủy yêu cầu
                      </b-dropdown-item>
                    </template>
                  </b-dropdown>
                </template>
              </b-table>
            </b-overlay>
            <update-package-popup
              ref="updatePackage"
              :id="currentActionId"
              :currentPackageCode="currentPackageCode"
              :currentPackageName="currentPackageName"
              @updated="onPackageUpdated"
            />
            <confirm-package-popup
              ref="confirmPackagePopup"
              :id="currentActionId"
              @confirmed="onPackageConfirmed"
            />
            <cancel-package-popup
              ref="cancelPopup"
              :id="currentActionId"
              @cancelled="onRequestCancelled"
            />
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="mr-4 fl-right"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { ComboService } from '@/services/combo.service'
  import moment from 'moment'
  import Config from '@/thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import { AgentService } from '@/services/agent.service'
  import UpdatePackagePopup from './UpdatePackagePopup.vue'
  import CancelPackagePopup from './CancelPackagePopup.vue'
  import ConfirmPackagePopup from './ConfirmPackagePopup.vue'
  import { mapGetters } from 'vuex'

  const tableFields = [
    { key: 'index', label: 'STT', thStyle: { width: '50px' } },
    { key: 'infoRequest', label: 'Thông tin YC' },
    { key: 'infoMerchant', label: 'Thông tin merchant' },
    { key: 'infoPackage', label: 'Thông tin gói' },
    { key: 'infoPayment', label: 'Thông tin thanh toán' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'rejectionNote', label: 'Ghi chú' },
    { key: 'action', label: 'Hành động', thStyle: { width: '140px' }, class: 'text-center' },
  ]

  const permissionEdit = 'CNPS_SCON_REQUEST_COMBO_UPDATE'

  export default {
    name: 'ComboRegistrationList',
    components: {
      UpdatePackagePopup,
      CancelPackagePopup,
      ConfirmPackagePopup,
    },
    data() {
      return {
        localeData: Config.localeData,
        showAddModal: false,
        addLoading: false,
        newRequest: {
          merchantName: '',
          businessRegistrationNumber: '',
          agentName: '',
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        loading: false,
        showLoading: false,
        tableFields,
        // Cập nhật bộ trạng thái mới
        optionStatus: [
          { id: 'NEW', text: 'Mới tạo', bgColor: 'badge-info' },
          { id: 'CANCELED', text: 'Đã hủy', bgColor: 'badge-danger' },
          { id: 'CONFIRMED', text: 'Đã xác nhận', bgColor: 'badge-success' },
        ],
        // Cập nhật bộ trạng thái thanh toán mới
        optionPaymentStatus: Config.optionPaymentStatusCombo,
        list: [],
        search: {
          page: 1,
          limit: 20,
          keySearch: '', // Thay đổi từ keyword thành keySearch
          code: '',
          regionCode: '', // Thay đổi từ regionIds thành regionCode
          status: '',
          paymentStatus: '',
          createdDateFrom: null, // Thay đổi từ fromDate thành createdDateFrom
          createdDateTo: null, // Thay đổi từ toDate thành createdDateTo
        },
        pagination: {
          total: 1,
        },
        dataAgent: [],
        dataConfigRegion: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        // popup state
        currentActionId: null,
        currentPackageCode: '',
        currentPackageName: '',
        permissionEdit,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },

    mounted() {
      this.fetchData()
      this.getRegions()
      this.getAgents()
    },

    watch: {
      'search.limit': function () {
        this.fetchData()
      },
      'search.page': function () {
        this.fetchData()
      },
    },

    methods: {
      getDigitalSignatureRegistrationStatus(status) {
        const map = Config.digitalSignatureRegistrationStatus?.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[status] || 'badge-secondary'
      },
      getTaxAuthorityVerifyStatus(status) {
        const map = Config.taxAuthorityVerifyStatus?.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[status] || 'badge-secondary'
      },
      // Cập nhật method transfromDate
      transfromDate() {
        this.search.createdDateFrom = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.createdDateTo = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      async getAgents() {
        const response = await AgentService.getListAgentPartner({ limit: 1000, page: 1 })
        if (response.code === 1000) {
          this.dataAgent =
            response.data.map(e => ({
              id: e.agentId,
              text: e.name,
            })) || []
        }
      },
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          // Cập nhật để trả về regionCode thay vì id
          this.dataConfigRegion =
            data.data.map(e => ({
              id: e.regionCode || e.id, // Ưu tiên regionCode, fallback về id
              text: e.name,
            })) || []
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },

      openUpdatePackage(item) {
        // only allow if status is new
        const statusStr = (item.statusStr || '').toLowerCase()
        if (
          !item ||
          !(item.status === 'NEW' || statusStr.includes('mới') || statusStr.includes('mới tạo'))
        )
          return
        this.currentActionId = item.id
        this.currentPackageCode = item.invoicePackage?.code || ''
        this.currentPackageName = item.invoicePackage?.name || item.comboPackageName || ''
        this.$refs.updatePackage &&
          this.$refs.updatePackage.show({ invoicePackage: item.invoicePackage || {} })
      },
      async onPackageUpdated() {
        await this.fetchData()
      },

      openConfirmPackage(item) {
        if (!item || item.status !== 'NEW') return
        this.currentActionId = item.id
        const packageInfo = {
          name: item.invoicePackage?.name || item.comboPackageName || '',
          price: item.invoicePackage?.price || null,
        }
        this.$refs.confirmPackagePopup && this.$refs.confirmPackagePopup.show(packageInfo)
      },
      async onPackageConfirmed() {
        await this.fetchData()
      },

      openCancelRequest(item) {
        const statusStr = (item.statusStr || '').toLowerCase()
        if (
          !item ||
          !(item.status === 'NEW' || statusStr.includes('mới') || statusStr.includes('mới tạo'))
        )
          return
        this.currentActionId = item.id
        this.$refs.cancelPopup && this.$refs.cancelPopup.show()
      },
      async onRequestCancelled() {
        await this.fetchData()
      },
      getIndex(index) {
        return (this.search.page - 1) * this.search.limit + index + 1
      },

      getStatusBadgeClass(status) {
        const map = this.optionStatus.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[status] || 'badge-secondary'
      },

      getPaymentStatusBadgeClass(paymentStatus) {
        const map = this.optionPaymentStatus.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[paymentStatus] || 'badge-secondary'
      },

      async resetFilters() {
        this.search = {
          page: 1,
          limit: 20,
          keySearch: '',
          regionCode: '',
          status: '',
          paymentStatus: '',
          createdDateFrom: null,
          createdDateTo: null,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },

      viewDetails(id) {
        this.$router.push(`/request-sales-combo-detail-tingbox/${id}`)
      },

      async fetchData() {
        if (!this.loading) this.showLoading = true
        try {
          this.loading = true

          // Tạo object search mới theo format API
          const searchParams = {
            page: this.search.page,
            limit: this.search.limit,
          }

          // Chỉ thêm các field có giá trị
          if (this.search.keySearch && this.search.keySearch.trim()) {
            searchParams.keySearch = this.search.keySearch.trim()
          }
          if (this.search.code && this.search.code.trim()) {
            searchParams.code = this.search.code.trim()
          }

          if (this.search.createdDateFrom) {
            searchParams.createdDateFrom = this.search.createdDateFrom
          }

          if (this.search.createdDateTo) {
            searchParams.createdDateTo = this.search.createdDateTo
          }

          if (this.search.regionCode) {
            searchParams.regionCode = this.search.regionCode
          }

          if (this.search.status) {
            searchParams.status = this.search.status
          }

          if (this.search.paymentStatus) {
            searchParams.paymentStatus = this.search.paymentStatus
          }

          const response = await ComboService.getListTingbox(searchParams)
          if (response.code === 1000) {
            this.list = response.data || []
            this.pagination.total = response.totalPage.total || 0
          } else {
            this.list = []
            this.pagination.total = 0
          }
        } catch (error) {
          console.error('Error fetching data:', error)
          this.list = []
          this.pagination.total = 0
        } finally {
          this.loading = false
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
